import RefappBackToTop from './components/refapp-back-to-top.vue';

export default {
  install(app) {
    const components = [RefappBackToTop];
    components.forEach((c) => app.component(c.name, c));
  },
};
